import { useContext, useEffect } from 'react';
import { prefetchCriticalAdminData } from "../queries/prefetch";
import { AuthContext } from "../context/Auth/AuthContext";
import { isBillingRestricted } from "../utils/billing";

// Preloading das páginas mais críticas do sistema
const usePagePreloader = () => {
  const { isAuth, user, billing, billingLoading } = useContext(AuthContext);
  const companyId = user?.companyId;
  const accessKey = isAuth && companyId && billing && !billingLoading && !isBillingRestricted(user, billing)
    ? `${companyId}:${user.id}` : null;

  useEffect(() => {
    if (!accessKey) return undefined;
    let cancelled = false;
    const timer = setTimeout(() => {
      prefetchCriticalAdminData({ companyId, canPrefetch: () => !cancelled });
    }, 2600);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [accessKey, companyId]);

  useEffect(() => {
    // Aguarda um pouco após o carregamento inicial para não interferir
    const preloadTimer = setTimeout(() => {
      // Páginas mais acessadas que devem ser precarregadas
      const criticalPages = [
        () => import("../pages/Dashboard/"),
        () => import("../pages/TicketResponsiveContainer"),
        () => import("../pages/Contacts/"),
        () => import("../pages/Kanban"),
      ];

      // Páginas secundárias (preload com delay maior)
      const secondaryPages = [
        () => import("../pages/Users"),
        () => import("../pages/Connections/"),
        () => import("../pages/QuickMessages/"),
        () => import("../pages/Queues/"),
      ];

      // Preload das páginas críticas imediatamente
      criticalPages.forEach((importFn, index) => {
        setTimeout(() => {
          importFn().catch(() => {
            // Ignora erros de preload silenciosamente
          });
        }, index * 200); // Espaça os preloads para não sobrecarregar
      });

      // Preload das páginas secundárias após um delay maior
      setTimeout(() => {
        secondaryPages.forEach((importFn, index) => {
          setTimeout(() => {
            importFn().catch(() => {
              // Ignora erros de preload silenciosamente
            });
          }, index * 300);
        });
      }, 2000);

    }, 1000); // Aguarda 1s após o carregamento inicial

    return () => clearTimeout(preloadTimer);
  }, []);
};

export default usePagePreloader;
